import format from 'date-fns/format';

export interface FormatDateOptions {
  format?: string;
  monthFormat?: 'numeric' | 'short' | 'long';
  includeWeekday?: boolean;
  weekdayFormat?: 'short' | 'long';
  locale?: string;
}

export function formatDateToYMD(date: Date | string | null): string | null {
  if (!date) return null;
  if (date instanceof Date) {
    return date.toISOString().split('T')[0]; // YYYY-MM-DD
  }
  return date;
}

export function formatDateFull(
  dateStr: string,
  options: FormatDateOptions = {}
): string {
  if (!dateStr) return '';
  const [datePart] = dateStr.split('T');
  const [yearStr, monthStr, dayStr] = datePart.split('-');
  const yearNum = Number(yearStr);
  const monthNum = Number(monthStr); // 1-12
  const dayNum = Number(dayStr);
  if (!yearNum || !monthNum || !dayNum) return '';

  const date = new Date(Date.UTC(yearNum, monthNum - 1, dayNum));

  const {
    format,
    monthFormat = 'numeric',
    includeWeekday = false,
    weekdayFormat = 'short',
    locale = 'en-US',
  } = options;

  const day = String(dayNum).padStart(2, '0');
  const year = yearNum;

  let month: string;
  if (monthFormat === 'numeric') {
    month = String(monthNum).padStart(2, '0');
  } else {
    month = date.toLocaleString(locale, {
      month: monthFormat,
      timeZone: 'UTC',
    });
  }

  let result = format
    ? format
        .replace('YYYY', year.toString())
        .replace('MM', month)
        .replace('DD', day)
    : `${month}/${day}/${year}`;

  if (includeWeekday) {
    const weekday = date.toLocaleString(locale, {
      weekday: weekdayFormat,
      timeZone: 'UTC',
    });
    result = `${weekday}, ${result}`;
  }

  return result;
}

export function formatLongDate(
  date: Date,
  options: {
    includeYear?: boolean;
    weekdayFormat?: 'long' | 'short';
  } = {}
): string {
  const { weekdayFormat = 'short', includeYear = false } = options;
  if (!date) return '';
  const weekdayToken = weekdayFormat === 'long' ? 'EEEE' : 'EEE';
  const yearToken = includeYear ? ', yyyy' : '';

  const formatString = `${weekdayToken}, MMMM dd${yearToken}`;
  return format(date, formatString);
}
